import React, {
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom";
import { getTrans as T } from "../../../Shared/Language";
import { useSelector } from "react-redux";
import { feedLikePost, feedPostComment, getFeed } from "../Dashboard/Services/DashboardServices";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { TostMsg } from "../../../App";
import { Carousel } from "primereact/carousel";
import moment from "moment";
import { debounce } from 'lodash';
import { getEmployeeList } from "../EmployeeList/Service/employeeService";
import Commnent from "../../../Services/Comment/comment";
import { PostDate } from "../Dashboard/CommonComponents/PostDate";
const FeedCarousel = React.lazy(() =>
  import("../Dashboard/DashboardFeed/FeedCarousel").then((module) => ({ default: module.FeedCarousel }))
);
const defaultImage = "/images/placeholder_profile.png";
const ComponentLoader = React.lazy(() =>
  import("../../../Shared/Sidebar/ComponentLoader")
);

const SearchResult = () => {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const ApplySearchRequestData = useSelector((state) => state?.searchResult.searchRequestData);
  const [Isloading, setIsloading] = useState(false);
  const [feedLst, setFeelLst] = useState([]);
  const [searchedEmployeeList, setsearchedEmployeeList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const toster = useContext(TostMsg);
  const history = useHistory();
  const [feedText, setFeedText] = useState("");

  const responsiveOptions = [
    {
      breakpoint: "1400px",
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: "1199px",
      numVisible: 3,
      numScroll: 1,
    },
    {
      breakpoint: "767px",
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: "575px",
      numVisible: 1,
      numScroll: 1,
    },
  ];


  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  useEffect(() => {
    if (ApplySearchRequestData) {
      GetFeed();
      fetchEmployeeIdData();
      fetchSerchEmployeeIdData();
    } else {
      history.push(`/Dashboard`);
    }

  }, [ApplySearchRequestData]);

  //Get Feed List
  async function GetFeed() {
    const body = {
      OrgId: userDetails?.OrgId,
      EmpId: 0,
      FeedId: 0,
      EmpGUID: '',
      FeedGUID: "",
      pageNumber: 1,
      IsFeatured: 0,
      pageSize: 100000,
      LoggedInUserId: userDetails?.EmpId,
      FeedGUID: "",
    };
    try {
      let res = await getFeed(body);
      handleSearchFilter(res.Data);
    } catch (error) {
      toster.current.error(ERROR_LIST?.DashboardFeed);
    }
  }


  const handleSearchFilter = debounce((data) => {
    const searchValue = ApplySearchRequestData?.toLowerCase?.() || "";
    if (searchValue) {
      const filteredList = data?.filter((item) =>
        item?.PostedBy?.toLowerCase()?.includes(searchValue),
      );
      setFeelLst(filteredList);
    }
  }, 800);

  //For get the employee data.
  async function fetchSerchEmployeeIdData() {
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: ApplySearchRequestData,
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 1000000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
    };
    try {
      let res = await getEmployeeList(params);
      setsearchedEmployeeList(res.Data);
    } catch (error) {
      toster.current.error(ERROR_LIST.EmployeeListDataError)
    }
  }

  async function fetchEmployeeIdData() {
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: '',
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 1000000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
    };
    try {
      let res = await getEmployeeList(params);
      setEmployeeList(res.Data);
    } catch (error) {
      toster.current.error(ERROR_LIST.EmployeeListDataError)
    }
  }

  async function FeedPostComment(Feedlst, mentionedArr, CommentText, FeedId) {
    if (FeedId) {
      const body = {
        FeedId: FeedId,
        EmpId: userDetails?.EmpId,
        ParentCommentId: 0,
        Comment: CommentText,
        PostMentions: mentionedArr,
      };
      try {
        await feedPostComment(body);
        setFeedText("");
        GetFeed();
      } catch (error) {
        toster.current.error(ERROR_LIST?.FeedPostOnComment);
      }
    } else {
      toster.current.error(ERROR_LIST?.FeedPostOnComment);
    }
  }

  const renderFeedText = (text) => {
    const mentionRegex = /@\w+/g;
    const hashtagRegex = /#\w+/g;
    let FeedText = text?.LastComment;
    let newText = FeedText?.replace(mentionRegex, (mention) => {
      return mention.replace("@", "");
    });
    newText = newText?.replace(hashtagRegex, (hashtag) => {
      return `<a  style={{ color: "#c4c6c7" }}>${hashtag}</a>`;
    });
    return { __html: newText };
  };

  async function FeedLikePost(lst) {
    const updatedFeedList = feedLst.map((item) => {
      if (item.Id !== lst.Id) return item;
      let updatedItem = { ...item };
      if (item.IsLastCommentLikedByMe == 1) {
        updatedItem = {
          ...item,
          IsLastCommentLikedByMe: Math.max(0, item.IsLastCommentLikedByMe - 1),
          LastCommentLikeCount: Math.max(0, item.LastCommentLikeCount - 1),
        };
      } else {
        updatedItem = {
          ...item,
          IsLastCommentLikedByMe: item.IsLastCommentLikedByMe + 1,
          LastCommentLikeCount: item.LastCommentLikeCount + 1,
        };
      }
      return updatedItem;
    });
    setFeelLst(updatedFeedList);
    let isLike = lst.MyReaction !== "Like";
    const body = {
      FeedId: Number(lst.Id),
      CommentId: lst.LastCommentId || 0,
      ReactionById: userDetails?.EmpId,
      ReactionTypeId: 101,
      Reaction: "Like",
      IsLike: isLike,
    };
    try {
      await feedLikePost(body);
    } catch (error) {
      toster.current.warn(ERROR_LIST.DashboardLike);
    }
  }

  const feedTemplate = (feeds) => {
    if (feeds?.MediaPath) {
      return (

        <div className="post-image">
          <div className="masonry-grid">
            <div className="masonry-column-left">
              <a
                data-fancybox="post3"
                data-lightbox-type="comments"
                style={{ padding: "0" }}
              >
                <img src={feeds?.MediaPath} />
              </a>
            </div>
            <div className="masonry-column-right"></div>
            <div className="like-wrapper">
              <div className="like-button">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  style={{ color: "white" }}
                  fill="currentColor"
                  className="bi bi-suit-heart-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M4 1c2.21 0 4 1.755 4 3.92C8 2.755 9.79 1 12 1s4 1.755 4 3.92c0 3.263-3.234 4.414-7.608 9.608a.513.513 0 0 1-.784 0C3.234 9.334 0 8.183 0 4.92 0 2.755 1.79 1 4 1z"></path>
                </svg>
                <span className="like-overlay"></span>
              </div>
            </div>

            <div className="fab-wrapper is-comment">
              <div className="small-fab">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-message-circle"
                >
                  <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
                </svg>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <p></p>
      )
    }

  };

  const handleLastName = (name) => {
    if (name == "success") {
      GetFeed(false);
    }
  };

  return (
    <div>
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>
        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row ">
          <div className="form-head d-flex flex-wrap align-items-center mb-5">
            <div className="me-auto">
              <h2 className="font-w600 mb-0">
                Search Result - {ApplySearchRequestData}
              </h2>
            </div>
            <div className="rightside-tabs">
              <div className="me-auto">
                <Link
                  to="/Dashboard"
                  className="btnlogin-bx btn"
                  style={{ cursor: "pointer" }}
                  aria-expanded="false"
                  data-toggle="tooltip"
                  data-placement="right"
                  title=""
                  data-bs-original-title="Back"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-arrow-left"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
                    />
                  </svg>
                  Back
                </Link>
              </div>
            </div>
          </div>
          <div className="col-xl-12">
            <div id="" className="row justify-content-center gx-3">
              <div className="col-lg-3">
                <h4 className="recent_h4">
                  {T("Employees")} (
                  {searchedEmployeeList.length})
                </h4>
                <div className="recent">
                  {searchedEmployeeList?.map((search) => (
                    <div className="recent-block">
                      <Link to={`/Profile/${search.GUID}`} className="media-flex-center">
                        <div className="h-icon is-orange is-rounded is-small">
                          <img
                            className="avatar"
                            src={search?.ProfileImage || defaultImage}
                            onError={handleImageError}
                          />
                        </div>
                        <div className="flex-meta">
                          <span>{search?.FullName}</span>
                          <span>{search?.CurrentDesignation}</span>
                        </div>
                      </Link>
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-lg-7">
                <h4 className="recent_h4">Post ({feedLst?.length})</h4>
                {
                  feedLst && feedLst.length > 0 && (
                    <div className="recent3  postlist">
                       <div className="row gx-3 gy-1">
                        {feedLst?.map((feed, index) => (
                          <div className="col-md-6">
                            <div className="recent-block">
                              <div key={index} className="card is-post">
                                <div className="content-wrap mm-active">
                                  <div className="card-heading p-0">
                                    <Link to={`/Feed/Post/${feed?.GUID}`}>
                                      <div className="user-block d-flex ">
                                        <div className="image mr-3">
                                          <img
                                            className="avatar"
                                            src={feed?.ProfilePic || defaultImage}
                                            onError={handleImageError}
                                          />
                                        </div>
                                        <div className="user-info mm-active p-0 mt-2">
                                          <a className="p-0 mm-active">{feed?.PostedBy}</a>
                                          <span className="time">
                                            {moment(feed?.CreatedDate).format('MMM DD YYYY')}
                                          </span>
                                        </div>
                                      </div>
                                    </Link>
                                  </div>
                                  <div className="">
                                    <FeedCarousel
                                      templateData={feed}
                                      itemIndex={index}
                                      onPassResponse={handleLastName}
                                    />
                                    <div className="card-footer d-block commentdiv">
                                      <a>
                                        <div className="send-output">
                                          <img
                                            className="pro-img"
                                            src={userDetails?.ProfileImage || defaultImage}
                                            onError={handleImageError}
                                            title={userDetails?.FullName}
                                            data-user-popover="1"
                                            alt=""
                                          />
                                          <Commnent
                                            key={index}
                                            sendCommentData={FeedPostComment}
                                            reciveCommentData={feedText}
                                            employeesList={employeeList}
                                            commentType={feed?.Id}
                                          />
                                        </div>
                                      </a>
                                      {feed?.LastComment && (
                                        <div className="feed-comments-bottomdiv">
                                          <img
                                            src={
                                              feed?.LastCommentByProfilePic || defaultImage
                                            }
                                            onError={handleImageError}
                                            title={feed?.LastCommentByProfilePic}
                                            data-user-popover="1"
                                            alt=""
                                          />
                                          <div className="comment-textdiv bg-light rounded-start-top-0 rounded">
                                            <div className="d-flex justify-content-between">
                                              <h6 className="mb-1">
                                                <Link
                                                  to={`/Profile/${feed?.LastCommentGUID}`}
                                                >
                                                  {feed?.LastCommentBy}
                                                </Link>
                                              </h6>
                                              <small className="ms-2">
                                                <PostDate
                                                  LastCommentDate={feed?.LastCommentDate}
                                                />
                                              </small>
                                            </div>
                                            <p
                                              className="small break-text"
                                              dangerouslySetInnerHTML={renderFeedText(
                                                feed
                                              )}
                                            ></p>
                                            <p className="like-button">
                                              <a className="me-3">
                                                {feed?.IsLastCommentLikedByMe ? (
                                                  <a onClick={() => FeedLikePost(feed)}>
                                                    {" "}
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="16"
                                                      height="16"
                                                      fill="currentColor"
                                                      className="bi bi-heart-fill"
                                                      viewBox="0 0 16 16"
                                                    >
                                                      <path
                                                        fillRule="evenodd"
                                                        d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314"
                                                      />
                                                    </svg>
                                                  </a>
                                                ) : (
                                                  <a
                                                    onClick={() =>
                                                      FeedLikePost(feed, "Like")
                                                    }
                                                  >
                                                    <i className="fa fa-heart-o like-button"></i>
                                                  </a>
                                                )}
                                                <b>
                                                  {feed?.LastCommentLikeCount >= 1
                                                    ? feed?.LastCommentLikeCount
                                                    : ""}
                                                </b>
                                              </a>
                                              <Link
                                                to={`/Feed/Post/${feed?.GUID}`}
                                                className="atag"
                                              >
                                                <a>
                                                  <i
                                                    className="fa fa-quote-right"
                                                    aria-hidden="true"
                                                  ></i>
                                                </a>
                                              </Link>
                                              <span className="like-overlay"></span>
                                            </p>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )
                }
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="contact-manager">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title m-auto">
                Contact Your Reporting Manager htmlFor Any Leave Clarifications
              </h5>
            </div>
            <div className="modal-body text-center">
              <form>
                <div className="form-group text-left">
                  <label>Repoting Manager</label>
                  <select className="default-select form-control wide mb-3">
                    <option selected disabled>
                      Select reporting manager
                    </option>
                    <option>Arun Mishra</option>
                    <option>Pragya Tiwari</option>
                    <option>Alisha Goyal</option>
                  </select>
                </div>
                <div className="form-group text-left">
                  <label className="mt-3">Reason</label>
                  <textarea
                    rows="4"
                    cols="1"
                    className="form-control"
                  ></textarea>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger light"
                data-bs-dismiss="modal"
              >
                Decline
              </button>
              <button type="button" className="btn btn-primary">
                Accept
              </button>
            </div>
          </div>
        </div>
      </div>
      {Isloading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
};

export default SearchResult;
